<ng-container *ngIf="(busyService.busyState$ | async) as busyState">
  <div *ngIf="busyState.isBusy" class="progress-bar">
    <mat-progress-bar class="" mode="indeterminate"></mat-progress-bar>
  </div>
</ng-container>

<div class="page">
  <div class="sidebar-wrapper" *ngIf="!hideSidebar">
    <app-sidebar></app-sidebar>
  </div>

  <div [hidden]="(routesService.showSecondOutlet$ | async) === false"
       class="router-outlet second-router-outlet">
    <router-outlet name="second"></router-outlet>
  </div>
  <div [hidden]="(routesService.showSecondOutlet$ | async) === true" class="router-outlet">
    <router-outlet></router-outlet>
  </div>

<!--  <ng-container *ngIf="temporalPageService.temporalPageData$ | async as temporalPageData">-->
<!--    <div [hidden]="temporalPageData.enabled === false" class="router-outlet">-->
<!--      <app-temporal-page></app-temporal-page>-->
<!--    </div>-->
<!--    <div [hidden]="temporalPageData.enabled === true" class="router-outlet">-->
<!--      <router-outlet></router-outlet>-->
<!--    </div>-->
<!--  </ng-container>-->
</div>

<app-unsaved-changes></app-unsaved-changes>

<app-application-update-required
  *ngIf="(appVersionService.showAppUpdateSuggestion$ | async) as showUpdate"
  [params]="showUpdate"
></app-application-update-required>
